<template>
  <footer class="footer">
    <div class="footer-content">
      <div class="top-content">
        <div class="left">
          <div class="information">
            <div class="zixun">
              <h1>售前咨询</h1>
              <h2>0579-86688168</h2>
            </div>
            <div class="info">供应链邮箱：ysl33365788@master.com</div>
            <div class="info">地址：沈阳市于洪区工匠网络</div>
            <div class="info">工作时间：周一至周五 9:00-18:00</div>
          </div>
          <div class="contact">
            <ul>
              <li class="title">新闻公告</li>
              <li class="content">新闻资讯</li>
            </ul>
            <ul>
              <li class="title">关于我们</li>
              <li class="content">公司介绍</li>
              <li class="content">企业文化</li>
            </ul>
            <ul>
              <li class="title">加入我们</li>
              <li class="content">校园招聘</li>
              <li class="content">社会招聘</li>
            </ul>
          </div>
        </div>
        <div class="qr-code">
          <img src="../assets/qrcode.png" alt="qr-code" />
          <img src="../assets/qrcode.png" alt="qr-code" />
        </div>
      </div>
      <div class="bottom-content">
        <img src="../assets/little_logo.png" alt="" />
        <div class="copyright">
          <span>沈阳工匠网络网络科技有限公司 2007-现在 版权所有</span>
          <span>沈阳工匠网络网络科技有限公司 2007-现在 版权所有</span>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
};
</script>
<style scoped lang="scss">
.footer {
  width: 100%;
  background: #f7f8fb;
  .footer-content {
    max-width: 1650px;
    width: 100%;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    padding: 30px 0;
    box-sizing: border-box;
    .top-content {
      display: flex;
      justify-content: space-between;
      padding-bottom: 27px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
      box-sizing: border-box;
      .left {
        display: flex;
        justify-content: space-between;
        width: 60%;
        .information {
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          color: #000000;
          .zixun {
            margin-bottom: 17px;
            h1 {
              font-size: 18px;
            }
            h2 {
              font-size: 32px;
            }
          }
          .info {
            font-size: 12px;
            color: rgba(0, 0, 0, 0.6);
            margin-bottom: 10px;
          }
          .info:last-child {
            margin-bottom: 0;
          }
        }
        .contact {
          display: flex;
          gap: 130px;
          margin-left: auto;
          ul {
            display: flex;
            flex-direction: column;
            li {
              list-style: none;
            }
            .title {
              font-family: PingFang SC, PingFang SC;
              font-weight: 500;
              font-size: 16px;
              color: #121212;
              margin-bottom: 20px;
            }
            .content {
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 16px;
              color: #666666;
              margin-bottom: 10px;
              cursor: pointer;
            }
            li:hover {
              color: #001eb4;
            }
            .content:last-child {
              margin-bottom: 0;
            }
          }
        }
      }
      .qr-code {
        display: flex;
        gap: 45px;

        img {
          width: 144px;
          height: 171px;
        }
      }
    }
    .bottom-content {
      img {
        width: 104px;
        height: 34px;
        margin: 12px 0;
      }
      .copyright {
        display: flex;
        justify-content: space-between;
        span {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 13px;
          color: #000000;
        }
      }
    }
  }
  @media (max-width: 1785px) {
    .footer-content {
      max-width: 1450px;
    }
  }
}
</style>
